import React from 'react'; 
 
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from './store';
import history from 'common/history'
import {
    Link
} from 'react-router-dom';
import './index.css'
import Header from 'component/mobile_header' 

  
class Personal extends React.Component{
  componentWillMount(){
    // document.title = '个人中心';
  }   
  render(){ 
    return (
      <div> 
        <Header title = {'个人中心'}/>
        <div className="container"> personal</div>  
      </div>
      
      )
  }
}
 
 
const mapState = (state) => ({ 
  
  })
 

const mapDispatch = (dispatch) => ({
  
})
export default connect(mapState, mapDispatch)(Personal);
